<div class="container" *ngIf="course" [ngClass]="{ 'is-edit-mode': isEditMode }">
  <div class="content">
    <div class="title-row">
      <span class="ktitle-tiny">Course Sorting</span>
      <span class="klabel-medium">*Required field</span>
    </div>
    <span class="klabel-huge">Requirements</span>
    <span class="kbody-large">The requirement selections you make here determine which requirements
      this course can be applied to. If a user registers for this course but has
      not been assigned to any of the selected requirements made here, the user
      will only be able to apply this course to their Other/Personal Portfolio
      bucket.</span>
    <span class="klabel-medium label">Previous Requirements</span>
    <div class="chips">
      <app-chip class="outlined" *ngFor="let requirement of previousYearRequirements" [text]="requirement"></app-chip>
    </div>
    <span class="klabel-medium label">Select requirements*</span>
    <!--start-->
    <div class="kinput input-select-container kbody-large tree-container">
      <div class="kinput input-select-container kbody-large">
        <app-tree-checklist #requirementsinput class="tree" [label]="'Select requirements'"
          [dataset]="this.requirements || []" [existingData]="this.course?.requirementsList ?? []" [showItems]="true"
          (shareCheckedList)="
            updateLocalCourseParameter($event, 'requirements')
          ">
        </app-tree-checklist>
      </div>

      <span class="klabel-medium label" *ngIf="course?.requirementsList?.length > 0">Selections</span>
      <table class="table klabel-medium label">
        <thead>
          <tr>
            <th class="thl">Parent Requirement</th>
            <th class="thr">Sub-Requirement</th>
          </tr>
        </thead>
        <tbody>
          <tr class="tr" *ngFor="let entry of RequirementList">
            <td class="tdl">
              <div class="chips parent-requirement">
                <app-chip class="outlined requirement parent-requirement"
                  (closeChip)="removeAllFromArray(entry[0], 'requirements')" [closable]="true"
                  [text]="entry[0].topMostParentName || ''"></app-chip>
              </div>
            </td>

            <td class="tdr">
              <div class="chips child-requirements">
                <ng-container *ngFor="let requirement of entry">
                  <ng-container *ngIf="isSubRequirementChip(requirement)">
                    <app-chip class="outlined requirement child-requirement" (closeChip)="
                        removeAssetFromArray(requirement, 'requirements')
                      " [closable]="true" [text]="requirement.requirement || requirement.Requirement?.requirement || ''"></app-chip>
                  </ng-container>
                </ng-container>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- State Requirement Type Section - Only show if selected requirements have reportToStateFlag=1 -->
      <div *ngIf="showStateRequirementSection" class="state-requirement-section">
        <div style="display: flex; align-items: center; gap: 8px;">
          <span class="klabel-huge">State Requirement Type</span>
          <app-tooltip [tip]="getStateRequirementHelpText()"></app-tooltip>
        </div>
        <span class="kbody-large">
          One or multiple of the requirements you selected above are checked for "Report to State" - you must
          additionally select a State-Requirement-type.
        </span>
        <div></div>
        <span class="klabel-medium label">Select State Requirement Type<span
            *ngIf="isStateRequirementRequired">*</span></span>

        <div class="input-select-container kinput">
          <input #stateRequirementInput (change)="onStateRequirementChange($event)"
            (input)="onStateRequirementChange($event)" class="kinput klabel-large input-select" type="text"
            [placeholder]="isStateRequirementRequired ? 'Select a State Reporting Requirement*' : 'Select a State Reporting Requirement'"
            list="stateRequirementTargets" [value]="getSelectedStateRequirementText()"
            [required]="isStateRequirementRequired" />
          <datalist id="stateRequirementTargets" class="datalist">
            <option class="klabel-large" *ngFor="let stateReq of stateRequirements" [value]="stateReq.value">
              {{ stateReq.text }}
            </option>
          </datalist>
        </div>
      </div>

      <span class="klabel-huge">Tags</span>
      <span class="klabel-medium label">Select tags to attach to this course</span>
      <div class="input-select-container kinput">
        <input #tagsinput (change)="updateLocalCourseParameter($event, 'tags')" class="kinput kbody-medium input-select"
          type="text" placeholder="Type or select a tag" list="tagtargets" />
        <datalist id="tagtargets" class="datalist">
          <option class="kbody-medium" *ngFor="let tag of tags">
            {{ tag.tag.trim() }}
          </option>
        </datalist>
      </div>
      <span class="klabel-medium label" *ngIf="course?.tagsList?.length > 0">Selections</span>
      <div class="chips">
        <app-chip [dot]="tag?.color" class="outlined" (closeChip)="removeAssetFromArray(tag, 'tags')" [closable]="true"
          *ngFor="let tag of course?.tagsList ?? []" [text]="tag.tag"></app-chip>
      </div>

      <span class="klabel-huge">Categories</span>
      <span class="klabel-medium label">Select categories to attach to this course</span>
      <div class="input-select-container kinput">
        <input #categoriesinput (change)="updateLocalCourseParameter($event, 'categories')"
          class="kinput kbody-medium input-select" type="text" placeholder="Type or select a category"
          list="categorytargets" />
        <datalist id="categorytargets" class="datalist">
          <option class="kbody-medium" *ngFor="let category of categories">
            {{ category.category }}
          </option>
        </datalist>
      </div>
      <span class="klabel-medium label" *ngIf="course?.categoryList?.length > 0">Selections</span>
      <div class="chips">
        <app-chip class="outlined" (closeChip)="removeAssetFromArray(category, 'categories')" [closable]="true"
          *ngFor="let category of course?.categoryList ?? []" [text]="category.category"></app-chip>
      </div>
    </div>

  </div>
</div>